<template>
  <div>
    <layout>
      <div slot="content">
        <i-card title="航班管理">
          <template slot="right-menu">
            <el-button type="warning" size="medium" icon="el-icon-edit" @click="openBatchEditStockDialog">批量修改最近库存</el-button>
            <router-link :to="{name:'settings.add_sailings'}">
              <el-button type="success" size="medium" icon="el-icon-plus">添加航班</el-button>
            </router-link>
          </template>
          <div slot="content">
            <el-form :inline="true" size="small" style="text-align: right">
              <el-form-item>
                <el-select v-model="filter.sailings_code" filterable clearable placeholder="航班编号">
                  <el-option
                      v-for="(item,index) in sailingsCodeList"
                      :key="index +item.label"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="filter.sailings_title" filterable clearable placeholder="航班名称">
                  <el-option
                      v-for="(item,index) in sailingsTitleList"
                      :key="index +item.label"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getSailings">查找</el-button>
                <el-button type="primary">重置</el-button>
              </el-form-item>
            </el-form>
            <el-table :border="true" :highlight-current-row="true" :data="sailingsList" style="width: 100%">
              <el-table-column prop="id" width="80" label="航班id"></el-table-column>
              <el-table-column prop="sailings_code" width="120" label="航班编号"></el-table-column>
              <el-table-column prop="sailings_title" width="130" label="航班名称">
              </el-table-column>
              <el-table-column
                  min-width="180"
                  label="起止码头">
                <div slot-scope="scope">
                  {{ scope.row.start_wharf }} - {{ scope.row.end_wharf }}
                </div>
              </el-table-column>
              <el-table-column
                  label="时间信息"
                  width="120"
              >
                <div slot-scope="scope">
                  {{ scope.row.start_time }} - {{ scope.row.end_time }}
                </div>
              </el-table-column>
              <el-table-column
                  min-width="180"
                  label="集合信息"
              >
                <div slot-scope="scope">
                  <template v-if="scope.row.meeting_point || scope.row.meeting_time">
                    <div>{{ scope.row.meeting_point }} {{ scope.row.meeting_time }}</div>
                  </template>
                  <template v-else>
                    <span style="color: #909399;">暂无集合信息</span>
                  </template>
                </div>
              </el-table-column>
              <el-table-column
                  label="默认库存"
                  prop="default_stock"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="今日库存"
                  prop="today_stock"
                  width="100"
              >
                <template slot-scope="scope">
                  <el-input size="mini" @blur="editTodayStock(scope.row.id,scope.row.today_stock)"
                            v-model="scope.row.today_stock"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  label="销售状态"
                  width="80"
              >
                <template slot-scope="scope">
                  <el-tag size="mini" type="success" v-if="scope.row.on_sale === 1">销售中</el-tag>
                  <el-tag size="mini" type="danger" v-else>已下架</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  prop="created_at"
                  label="创建时间"
                  width="160"
              >
              </el-table-column>
              <el-table-column
                  label="操作"
                  fixed="right"
                  width="380"
              >
                <div slot-scope="scope" style="display: flex; gap: 8px; align-items: center;">
                  <router-link :to="{name:'settings.edit_sailings',query:{sailings_id:scope.row.id}}">
                    <el-button type="primary" size="mini">编辑</el-button>
                  </router-link>
                  <router-link
                      :to="{name:'settings.edit_sailings.sailings_stock',query:{sailings_id:scope.row.id}}">
                    <el-button type="primary" size="mini">库存管理</el-button>
                  </router-link>
                  <el-button type="warning" size="mini" @click="editRecentStock(scope.row)">修改近期库存</el-button>
                  <el-button type="danger" size="mini" @click="delSailing(scope.row.id)">删除</el-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </i-card>
      </div>
    </layout>

    <!-- 修改近期库存弹窗 -->
    <el-dialog 
      title="修改近期库存" 
      :visible.sync="recentStockDialogVisible" 
      width="800px"
      :before-close="handleCloseRecentStockDialog">
      <div v-if="currentSailing">
        <div style="margin-bottom: 20px;">
          <strong>航班信息：</strong>{{ currentSailing.sailings_title }} ({{ currentSailing.sailings_code }})
        </div>
        <el-table :data="recentStockList" border size="small" style="width: 100%">
          <el-table-column prop="date" label="日期" min-width="150"></el-table-column>
          <el-table-column prop="stock" label="当前库存" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.stock || 0 }} 张
            </template>
          </el-table-column>
          <el-table-column label="修改库存" min-width="180">
            <template slot-scope="scope">
              <el-input-number 
                v-model="scope.row.newStock" 
                :min="0" 
                size="mini" 
                style="width: 120px;">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button 
                type="primary" 
                size="mini" 
                @click="updateSingleStock(scope.row)"
                :loading="scope.row.loading">
                保存
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 批量修改最近库存弹窗 -->
    <el-dialog 
      title="批量修改最近库存" 
      :visible.sync="batchEditStockDialogVisible" 
      width="80%"
      :before-close="handleCloseBatchEditStockDialog">
      <div v-loading="batchLoading" element-loading-text="正在加载航班库存数据...">
        <template v-if="!batchLoading">
          <el-table v-if="batchSailingList.length > 0" :data="batchSailingList" border size="small" style="width: 100%; table-layout: fixed" max-height="600">
            <el-table-column prop="id" label="航班ID" width="100" fixed="left"></el-table-column>
            <el-table-column prop="sailings_code" label="航班编号" width="120" fixed="left"></el-table-column>
            <el-table-column prop="sailings_title" label="航班名称" width="150" fixed="left"></el-table-column>
            
            <!-- 动态生成日期列 -->
            <el-table-column 
              v-for="date in getUniqueDates()" 
              :key="date" 
              :label="formatDateHeader(date)"
              min-width="120">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row[`stock_${date}`]"
                  @blur="(event) => saveStockOnBlur(scope.row, date, event.target.value)"
                  size="mini" 
                  style="width: 100%;">
                </el-input>
              </template>
            </el-table-column>
          </el-table>
          <div v-else>
            <p style="text-align: center; color: #909399;">暂无数据</p>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "sailings",
  data: function () {
    return {
      sailingsList: [],
      filter: {
        sailings_code: "",
        sailings_title: ""
      },
      sailingsCodeList: [],
      sailingsTitleList: [],
      // 近期库存相关数据
      recentStockDialogVisible: false,
      currentSailing: null,
      recentStockList: [],
      // 批量修改库存相关数据
      batchEditStockDialogVisible: false,
      batchSailingList: [],
      batchSaveLoading: false,
      batchLoading: false,
      batchLoading: false
    }
  },
  methods: {
    getSailings: function () {
      this.sailingsCodeList = [];
      this.sailingsTitleList = [];
      this.$http.request('sailingsList', this.filter).then((res) => {
        this.sailingsList = res.data;
        let titleArr = [] ,codeArr = [];
        this.sailingsList.forEach(row => {
          titleArr.push(row.sailings_title)
          codeArr.push(row.sailings_code)
        })
        titleArr = Array.from(new Set(titleArr));
        codeArr = Array.from(new Set(codeArr));
        titleArr.forEach(item=>{
          this.sailingsTitleList.push({value:item,label:item});
        })
        codeArr.forEach(item=>{
          this.sailingsCodeList.push({value:item,label:item});
        })
      });
    },
    delSailing: function (sailingId) {
      this.$confirm('是否删除该航班？删除后不恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request('delSingsList', {sailings_id: sailingId}).then((res) => {
          let _self = this;
          if (res.status === 'success') {
            this.$message({
              type: 'success',
              message: res.message,
              onClose: function () {
                _self.getSailings();
              }
            });
          }
        });
      })
    },
    editTodayStock: function (stockId, stock) {
      this.$http.request('editSailingsStock', {sailings_id: stockId, stock: stock}).then(res => {
        this.$notify({
          title: '提示',
          message: res.message,
          type: res.status,
          duration: 2000
        });
      });
    },
    querySearch: function (eryu) {
      console.log(111)
    },
    
    // 修改近期库存相关方法
    editRecentStock: function (sailing) {
      this.currentSailing = sailing
      this.recentStockDialogVisible = true
      this.getRecentStockList(sailing.id)
    },
    
    // 获取近期库存列表
    getRecentStockList: function (sailingsId) {
      this.$http.request('sailingsStockList', { sailings_id: sailingsId }).then(res => {
        // 获取近7天的数据（从今天开始，包括今天）
        const today = new Date()
        // 使用本地时间，避免时区问题
        const todayLocal = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const recentDates = []
        
        for (let i = 0; i < 7; i++) {
          const date = new Date(todayLocal)
          date.setDate(todayLocal.getDate() + i)
          // 使用本地日期格式，避免时区转换问题
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          const dateStr = `${year}-${month}-${day}`
          recentDates.push(dateStr)
        }
        
        // 构建库存列表
        this.recentStockList = recentDates.map(date => {
          const existingStock = res.data ? res.data.find(item => item.date === date) : null
          return {
            date: date,
            stock: existingStock ? existingStock.stock : 0,
            newStock: existingStock ? existingStock.stock : 0,
            loading: false
          }
        })
      }).catch(error => {
        console.error('获取库存列表失败:', error)
        this.$message.error('获取库存列表失败')
      })
    },
    
    // 更新单个库存
    updateSingleStock: function (stockItem) {
      stockItem.loading = true
      const params = {
        sailings_id: this.currentSailing.id,
        date: stockItem.date,
        stock: stockItem.newStock
      }
      
      this.$http.request('editSailingsStock', params).then(res => {
        stockItem.loading = false
        if (res.status === 'success') {
          this.$message.success(`${stockItem.date} 库存更新成功`)
          stockItem.stock = stockItem.newStock
        } else {
          this.$message.error('库存更新失败')
        }
      }).catch(() => {
        stockItem.loading = false
        this.$message.error('库存更新失败')
      })
    },
    

    
    // 关闭弹窗
    handleCloseRecentStockDialog: function () {
      this.recentStockDialogVisible = false
      this.currentSailing = null
      this.recentStockList = []
    },
    
    // 批量修改库存相关方法
    openBatchEditStockDialog: function () {
      this.batchEditStockDialogVisible = true
      this.getBatchSailingList()
    },
    
    // 获取批量编辑的航班列表
    getBatchSailingList: function () {
      this.batchLoading = true
      this.$http.request('getSailingsWithRencentStock').then(res => {
        if (res.data && res.data.length > 0) {
          // 处理数据，为每个航班的库存添加编辑字段
          this.batchSailingList = res.data.map(sailing => {
            // 为每个库存项添加编辑字段
            const processedSailing = {
              ...sailing,
              loading: false
            }
            
            // 为每个库存项添加编辑字段
            if (processedSailing.recent_stock && processedSailing.recent_stock.length > 0) {
              processedSailing.recent_stock.forEach(stockItem => {
                processedSailing[`stock_${stockItem.date}`] = stockItem.stock
              })
            }
            
            return processedSailing
          })
        } else {
          this.batchSailingList = []
        }
        this.batchLoading = false
      }).catch(error => {
        console.error('获取航班列表失败:', error)
        this.$message.error('获取航班列表失败')
        this.batchSailingList = []
        this.batchLoading = false
      })
    },
    
    // 获取所有唯一的日期
    getUniqueDates: function () {
      const dateSet = new Set()
      this.batchSailingList.forEach(sailing => {
        if (sailing.recent_stock && sailing.recent_stock.length > 0) {
          sailing.recent_stock.forEach(stockItem => {
            dateSet.add(stockItem.date)
          })
        }
      })
      return Array.from(dateSet).sort()
    },
    
    // 格式化日期表头
    formatDateHeader: function (dateStr) {
      const date = new Date(dateStr)
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${month}月${day}日`
    },
    
    // 获取特定日期的库存值
    getStockForDate: function (sailing, date) {
      const stockItem = sailing.recent_stock ? sailing.recent_stock.find(item => item.date === date) : null
      return stockItem ? stockItem.stock : 0
    },
    
    // 设置特定日期的库存值
    setStockForDate: function (sailing, date, value) {
      if (!sailing.recent_stock) {
        sailing.recent_stock = []
      }
      
      const existingItem = sailing.recent_stock.find(item => item.date === date)
      if (existingItem) {
        existingItem.stock = value
      } else {
        sailing.recent_stock.push({
          date: date,
          stock: value,
          sailings_id: sailing.id
        })
      }
    },
    

    
    // 输入框失去焦点时保存库存
    saveStockOnBlur: function (sailing, date, value) {
      // 将输入值转换为数字
      const stockValue = parseInt(value) || 0
      
      // 更新本地数据
      this.setStockForDate(sailing, date, stockValue)
      
      // 调用保存接口
      const params = {
        sailings_id: sailing.id,
        date: date,
        stock: stockValue
      }
      
      this.$http.request('editSailingsStock', params).then(res => {
        if (res.status === 'success') {
          this.$message.success(`${date} 库存更新成功`)
        } else {
          this.$message.error('库存更新失败')
        }
      }).catch(() => {
        this.$message.error('库存更新失败')
      })
    },
    
    // 关闭批量编辑弹窗
    handleCloseBatchEditStockDialog: function () {
      this.batchEditStockDialogVisible = false
      this.batchSailingList = []
    }
  },
  created: function () {
    this.getSailings();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/sailings.vue